import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "clientFields",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading fields...",
      sortBy: "name",
      filter: "",
      fields: [
        { key: "client_name", label: "Client", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "acres", label: "Acres", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needClientFields", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
  computed: {
    clientFields: function() {
      return this.$store.getters.clientFields;
    },
  },
};
